var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.9366 17.5871L6.00434 18.0233C4.89744 18.0233 4 17.1171 4 15.9994C4 14.8817 4.89744 13.9756 6.00434 13.9756L10.9366 14.4118C11.805 14.4118 12.509 15.1226 12.509 15.9994C12.509 16.8777 11.805 17.5871 10.9366 17.5871Z",
    fill: "#3913D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4996 17.5069C27.4226 17.5847 27.1346 17.9137 26.864 18.1869C25.2859 19.8979 21.1652 22.6958 19.0096 23.552C18.6823 23.6886 17.8547 23.9794 17.411 24C16.9878 24 16.5834 23.9016 16.198 23.7077C15.7165 23.436 15.3325 23.0072 15.1202 22.5019C14.9849 22.1524 14.7725 21.1023 14.7725 21.0832C14.5616 19.9361 14.4467 18.0709 14.4467 16.0088C14.4467 14.0466 14.5616 12.2578 14.7347 11.0916C14.7536 11.071 14.966 9.76831 15.1973 9.32183C15.6205 8.50523 16.4481 8 17.334 8H17.411C17.9885 8.01909 19.2016 8.52579 19.2016 8.54342C21.2423 9.39967 25.2655 12.0624 26.8829 13.8322C26.8829 13.8322 27.3397 14.2875 27.5375 14.571C27.8458 14.9793 28 15.4845 28 15.9897C28 16.5537 27.8269 17.078 27.4996 17.5069Z",
    fill: "#3913D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.5221a27b.svg";
export { ForwardRef as ReactComponent };